import React, { useMemo, useState } from 'react';
import { Icon } from '@iconify/react';

const SitesWebSelect = ({
  label,
  value = '',
  onChange,
  options = [],
  placeholder = 'Tous',
  searchable = false,
  emptyLabel = 'Aucun résultat',
}) => {
  const [open, setOpen] = useState(false);
  const [query, setQuery] = useState('');

  const selected = options.find((option) => option.value === value);
  const needle = query.trim().toLowerCase();
  const visible = useMemo(() => {
    if (!open || !searchable || !needle) return options;
    return options.filter((option) => option.label.toLowerCase().includes(needle));
  }, [open, options, searchable, needle]);

  const close = () => {
    setOpen(false);
    setQuery('');
  };

  return (
    <div className="sw-field">
      {label}
      <div className="sw-select">
        <button
          type="button"
          className={`sw-select__btn${value ? ' is-set' : ''}${open ? ' is-open' : ''}`}
          onClick={() => {
            setOpen((current) => !current);
            setQuery('');
          }}
        >
          <span className="sw-select__label">{selected?.label || placeholder}</span>
          {value ? (
            <span
              role="button"
              tabIndex={0}
              title="Effacer"
              className="sw-select__clear"
              onClick={(event) => {
                event.stopPropagation();
                onChange('');
              }}
              onKeyDown={(event) => {
                if (event.key === 'Enter') {
                  event.stopPropagation();
                  onChange('');
                }
              }}
            >
              <Icon icon="lucide:x" width={13} />
            </span>
          ) : null}
          <Icon
            icon={open ? 'lucide:chevron-up' : 'lucide:chevron-down'}
            width={15}
            className="sw-select__chev"
          />
        </button>
        {open ? (
          <>
            <div className="sw-select__backdrop" onClick={close} />
            <div className="sw-select__menu">
              {searchable ? (
                <label className="sw-select__find">
                  <Icon icon="lucide:search" width={14} />
                  <input
                    autoFocus
                    value={query}
                    onChange={(event) => setQuery(event.target.value)}
                    placeholder="Rechercher…"
                  />
                </label>
              ) : null}
              <div className="sw-select__list">
                <button
                  type="button"
                  className={`sw-select__opt is-any${!value ? ' is-on' : ''}`}
                  onClick={() => {
                    onChange('');
                    close();
                  }}
                >
                  <span style={{ flex: 1, minWidth: 0 }}>{placeholder}</span>
                  {!value ? <Icon icon="lucide:check" width={14} style={{ color: 'var(--sw-accent)' }} /> : null}
                </button>
                {visible.map((option) => {
                  const on = option.value === value;
                  return (
                    <button
                      key={option.value}
                      type="button"
                      className={`sw-select__opt${on ? ' is-on' : ''}`}
                      onClick={() => {
                        onChange(option.value);
                        close();
                      }}
                    >
                      <span style={{ flex: 1, minWidth: 0 }}>{option.label}</span>
                      {on ? <Icon icon="lucide:check" width={14} style={{ color: 'var(--sw-accent)' }} /> : null}
                    </button>
                  );
                })}
                {searchable && needle && visible.length === 0 ? (
                  <span className="sw-select__empty">{emptyLabel}</span>
                ) : null}
              </div>
            </div>
          </>
        ) : null}
      </div>
    </div>
  );
};

export default SitesWebSelect;
